import { NODE_FIELD_FLAGS } from '#constants'
import type { Schema } from '#core'
import type * as pub from '#core'
import type { NonOverlappingUnion } from '#internal'

import { BaseClip } from './base-clip.ts'

export interface VideoClip extends NonOverlappingUnion<BaseClip<Schema.VideoClip>, pub.VideoClip> {}

export class VideoClip extends BaseClip<Schema.VideoClip> implements pub.VideoClip {
  static FIELDS = super.FIELDS.concat([
    ...BaseClip.VISUAL_FIELDS,
    { key: 'linkedAudio', flags: NODE_FIELD_FLAGS.Readonly | NODE_FIELD_FLAGS.Node },
  ] satisfies pub.NodeFieldDef<pub.VideoClip>[])

  declare asset: pub.MediaAsset | undefined

  get linkedAudio(): pub.AudioClip | undefined {
    const linkItem =
      this.link?.nodes.length === 2 ? this.link.nodes.find((n) => n.type === 'clip:audio') : undefined
    return linkItem && this.doc.nodes.get(linkItem.id)
  }

  isMediaClip(): this is VideoClip {
    return true
  }
  isVideo(): this is VideoClip {
    return true
  }

  toJSON(): Schema.VideoClip {
    const obj: Schema.VideoClip = {
      ...super.toJSON(),
      ...this._visualToJSON(),
    }

    return obj
  }
}
